// base url
const BASE_URL = 'https://coolowo.com/hardcoded-data-dashboard/'


// requests
const requests = {
    fetchData: `${BASE_URL}`,


}

export default requests